<template>
  <div
    class="c-cell" :class="classes"
    v-ripple="ripple"
    @click="onClick"
  >
    <div class="c-cell__month">
      <template v-if="showMonth">
        {{date.month}}月 <small>{{date.year}}年</small>
      </template>
    </div>
    <div class="c-cell__week">{{date.w}}</div>
    <div class="c-cell__day">{{date.day}}</div>
    <div class="c-cell__season"/>
    <div class="c-cell__state">
      <svg v-if="stateImage" class="c-cell__stateimg" width="20" height="20">
        <use :href="stateImage"/>
      </svg>
    </div>
  </div>
</template>

<style lang="scss">
/* Element: セル */
.c-calendar-bar .c-cell {
  cursor: default;
  display: inline-block;
  width: 31px;
  margin-right: 1px;
  overflow: visible;
}

/* Element: 曜日 */
.c-calendar-bar .c-cell__month {
  width: 68px;
  height: 20px;

  font-size: 13px;
  line-height: 16px;
  text-align: right;

  small {
    font-size: 9px;
  }
}

/* Element: 曜日 */
.c-calendar-bar .c-cell__week {
  font-size: 10px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
  background-color: var(--v-cal-week-base);
}

/* Element: 日付 */
.c-calendar-bar .c-cell__day {
  margin: 2px 6px 2px 5px;
  font-size: 13px;
  font-weight: bold;
  line-height: 20px;
  text-align: center;
  color: map-get(map-get($material-light, 'text'), 'disabled');

  .v-application.theme--dark & {
    color: map-get(map-get($material-dark, 'text'), 'disabled');
  }
}

/* Element: シーズン */
.c-calendar-bar .c-cell__season {
  $border-lt: rgba(black, .08);
  $border-rb: rgba(white, .24);

  margin-bottom: 1px;

  height: 3px;

  background-color: #E0E0E0;
  border-width: thin;
  border-style: solid;
  border-color: $border-lt $border-rb $border-rb $border-lt;
}

/* Element: 状態 */
.c-calendar-bar .c-cell__state {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modifier: カレンダー外 */
.c-calendar-bar .c-cell--outside {
  .c-cell__season {
    visibility: hidden;
  }
}

/* Modifier: 日曜日 */
.c-calendar-bar .c-cell--w0 {
  .c-cell__week {
    background-color: var(--v-cal-holiday-base);
  }

  .c-cell__day {
    color: var(--v-cal-holiday-base);
  }
}

/* Modifier: 土曜日 */
.c-calendar-bar .c-cell--w6 {
  .c-cell__week {
    background-color: var(--v-cal-saturday-base);
  }

  .c-cell__day {
    color: var(--v-cal-saturday-base);
  }
}

/* Modifier: 祝祭日 */
.c-calendar-bar .c-cell--holiday {
  .c-cell__day {
    color: #FFFFFF;
    background-color: var(--v-cal-holiday-base);
    border-radius: 50%;
  }
}

/* Modifier: キャンペーンシーズン */
.c-calendar-bar .c-cell--campaign {
  .c-cell__season {
    background-color: var(--v-cal-campaign-base);
  }
}

/* Modifier: ハイシーズン */
.c-calendar-bar .c-cell--high {
  .c-cell__season {
    background-color: var(--v-cal-high-base);
  }
}

/* Modifier: 終日予約可 */
.c-calendar-bar .c-cell--empty {
  cursor: pointer;

  .c-cell__stateimg {
    color: var(--v-cal-empty-base);
  }
}

/* Modifier: 一部予約可 */
.c-calendar-bar .c-cell--afew {
  cursor: pointer;

  .c-cell__stateimg {
    color: var(--v-cal-afew-base);
  }
}

/* Modifier: 予約不可 */
.c-calendar-bar .c-cell--occupied {
  .c-cell__stateimg {
    color: var(--v-cal-occupied-base);
  }
}

/* Modifier: 定休日 */
.c-calendar-bar .c-cell--closed {
  cursor: default;

  .c-cell__stateimg {
    color: var(--v-cal-closed-base);
  }
}
</style>

<script>
import DayStates from '@/assets/day-states.svg'

export default {
  name: 'CCell',

  props: {
    date: Object,
    state: String,
    showMonth: Boolean,
    anytime: Number
  },
  computed: {
    classes () {
      if (!this.date || !this.state) {
        return 'c-cell--outside'
      }
      let str = this.date.classes
      if (this.anytime === 1) {
        str = str.replace('c-cell--closed ', '')
      }
      return `${str} ${this.state}`
    },

    stateImage () {
      if (!this.date || !this.state) {
        return null
      }
      let imgid = ''
      if (this.date.closed && this.anytime === 0) {
        imgid = 'closed'
      } else if (this.state === 'c-cell--occupied') {
        imgid = 'occupied'
      } else if (this.state === 'c-cell--afew') {
        imgid = 'afew'
      } else {
        imgid = 'empty'
      }
      return DayStates + '#' + imgid
    },

    clickable () {
      if (!this.date || !this.state) {
        return false
      }
      if ((this.date.closed && this.anytime === 0) || this.state === 'c-cell--occupied') {
        return false
      }
      return true
    },

    ripple () {
      return !this.clickable ? null : { center: false, class: 'v-ripple' }
    }
  },
  methods: {
    onClick () {
      if (this.clickable) {
        this.$emit('selected', this.date)
      }
    }
  }
}
</script>
